<template>
	<el-form-item label="最大值">
		<el-input-number v-model="data.options.max" />
	</el-form-item>

	<el-form-item label="允许半选">
		<el-switch v-model="data.options.allowHalf" />
	</el-form-item>

	<el-form-item label="默认值">
		<el-rate v-model="data.options.defaultValue" :max="data.options.max" :allow-half="data.options.allowHalf" clearable />
	</el-form-item>
</template>

<script lang="ts">
import { defineComponent, ref, watch } from 'vue'

export default defineComponent({
	name: 'ItemRate',
	props: {
		active: {
			type: Object,
			default: null
		}
	},
	emits: ['update:active'],
	setup(props, context) {
		const data = ref(props.active)
		watch(data, val => context.emit('update:active', val), { deep: true })

		return {
			data
		}
	}
})
</script>
